module.exports = __webpack_public_path__ + "img/tool_bg_sensor_dataset.a90af0da.svg";